import type { AppliedPromotion } from '@/services/promotion.service';

/**
 * TCR-1403 — suy ra tập `promotion_id` còn hợp lệ để `CustomerSidebar` báo ra
 * ngoài cho `usePromotionGiftAdd` cascade-gỡ quà CTKM mồ côi. `null` = CHƯA
 * CÓ tín hiệu chắc chắn (đừng cascade); mảng (kể cả rỗng) = tín hiệu CHẮC
 * CHẮN, an toàn để hành động.
 *
 * Trường hợp đặc biệt cần `hasEvaluableCartItems`: sau khi xoá sản phẩm điều
 * kiện, giỏ có thể chỉ còn dòng quà (`is_gift`) — `buildEvaluateItems` loại
 * hết dòng quà nên payload evaluate rỗng, evaluate KHÔNG BAO GIỜ được gọi lại
 * ở trạng thái này (`promotionEvaluationFresh` mắc kẹt ở `false` vĩnh viễn, vì
 * không còn gì để gửi lên BE chấm). Nhưng suy luận cục bộ vẫn chắc chắn: 0
 * dòng hàng thật ⇒ không CTKM nào còn thoả điều kiện ⇒ trả `[]` ngay, không
 * cần đợi một network round-trip sẽ không bao giờ xảy ra.
 */
export function resolveAppliedPromotionIds(params: {
  showAutoPromotions: boolean;
  hasEvaluableCartItems: boolean;
  promotionEvaluationFresh: boolean;
  appliedPromotions: Pick<AppliedPromotion, 'promotion_id'>[];
}): string[] | null {
  if (!params.showAutoPromotions) return null;
  if (!params.hasEvaluableCartItems) return [];
  if (!params.promotionEvaluationFresh) return null;
  return params.appliedPromotions.map((p) => p.promotion_id);
}
